import { FC, Fragment } from "react";
import { LabelInputCard } from "../atoms/LabelInputCard";
import { InputCardCVC } from "../atoms/InputCardCVC";
import { InputCardDate } from "../atoms/InputCardDate";

export type InputGroupCardprops = {
  idOne: string;
  nameOne: string;
  placeholderOne: string;
  idTwo: string;
  nameTwo: string;
  placeholderTwo: string;
};

export const InputGroupCard: FC<InputGroupCardprops> = ({
  idOne,
  nameOne,
  placeholderOne,
  idTwo,
  nameTwo,
  placeholderTwo,
}) => {
  return (
    <Fragment>
      <div className="flex -space-x-px">
        <div className="w-1/2 min-w-0 flex-1">
          <InputCardDate
            id={idOne}
            name={nameOne}
            placeholder={placeholderOne}
          />
        </div>
        <div className="min-w-0 flex-1">
          <InputCardCVC
            id={idTwo}
            name={nameTwo}
            placeholder={placeholderTwo}
          />
        </div>
      </div>
    </Fragment>
  );
};
